import { useContext, useState } from "react";
import { apiRequest } from "../../api/baseApi";
import Layout from "../../components/layout/Layout";
import { useSyncSelectedClient } from "../../Hooks/useSyncSelected";
import { AuthContext } from "../../state/AuthContext";
import { ClientContext } from "../../state/ClientContext";
import { toTitleCase } from "../../util/toTitleCase";
import CaregiverAssignments from "./CaregiverAssignments";
import CaregiverDetailsForm from "./CaregiverDetailsForm";
import { useNavigate } from "react-router-dom";
import DeleteConfirmationModal from "../../components/modals/DeleteConfirmationModal";

const CaregiverProfilePage = () => {
  const { selectedCaregiver, deleteCaregiver, isDeletingCaregiver } =
    useContext(ClientContext);
  const { currentUser } = useContext(AuthContext);
  const navigate = useNavigate();
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  useSyncSelectedClient();

  const handleDelete = async () => {
    if (!selectedCaregiver?.id) return;

    try {
      await deleteCaregiver(selectedCaregiver.id);
      setShowDeleteModal(false);
      navigate("/select-client-homepage");
    } catch (error) {
      console.error("Error deleting caregiver:", error);
    }
  };

  const handleResendInvite = async (e) => {
    e.preventDefault();
    try {
      const response = await apiRequest("/users/resendInvite", {
        method: "POST",
        body: { email: selectedCaregiver.email },
        version: "v1",
      });
      if (response.ok) {
        const data = await response.json();
        alert(data.message);
      } else {
        console.error("Failed to resend invite");
      }
    } catch (error) {
      console.error("Error resend invite", error);
    }
  };

  if (!selectedCaregiver) {
    return null;
  }

  return (
    <Layout containerClassName="bg-page-light" showSideNav={false}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "16px",
          marginLeft: "40px",
          paddingTop: "20px",
        }}
      >
        <h1 style={{ fontWeight: 800, margin: 0 }}>
          <span style={{ fontSize: "2.4rem", color: "#222" }}>
            {toTitleCase(selectedCaregiver.name)}
          </span>
        </h1>

        {selectedCaregiver.isActive ? (
          <div
            style={{
              backgroundColor: "#ACAF81",
              color: "#32693A",
              fontSize: "1rem",
              padding: "4px 8px",
              borderRadius: "4px",
            }}
          >
            Registered
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              fontSize: "1rem",
              gap: "12px",
              alignItems: "center",
            }}
          >
            <div
              style={{
                backgroundColor: "#ACAF81",
                color: "#FE0909",
                padding: "4px 8px",
                borderRadius: "4px",
              }}
            >
              Unregistered
            </div>
            <a
              href="#"
              onClick={handleResendInvite}
              style={{
                color: "#007BFF",
                textDecoration: "underline",
                marginTop: "2px",
                fontSize: "0.9rem",
              }}
            >
              Resend Invite
            </a>
          </div>
        )}
      </div>
      <div
        data-testid="caregiver-profile-columns"
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "16px",
          padding: "16px",
        }}
      >
        <div style={{ flex: "1 1 480px", minWidth: 0 }}>
          <CaregiverDetailsForm />
          {(currentUser?.isSuperAdmin || currentUser?.isAdmin) && (
            <button
              className={`delete-client btn-danger`}
              onClick={() => setShowDeleteModal(true)}
            >
              Delete caregiver
            </button>
          )}
        </div>

        <div style={{ flex: "1 1 480px", minWidth: 0 }}>
          <CaregiverAssignments />
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      <DeleteConfirmationModal
        isOpen={showDeleteModal}
        isLoading={isDeletingCaregiver}
        itemName={selectedCaregiver.name}
        itemType="Caregiver"
        warningMessage="All associated data and assignments will be permanently removed."
        onConfirm={handleDelete}
        onCancel={() => setShowDeleteModal(false)}
      />
    </Layout>
  );
};

export default CaregiverProfilePage;
